export default __webpack_public_path__ + "static/media/carTwo.494268a0.jpg";